import Service from "../../services";
import { checkAndReturn } from "../../main";

const state = {};

const getters = {};

const actions = {
  async kpi({ commit }, data) {
    return await Service.Dashboard.kpi(data.payload).then((res) => {
      return checkAndReturn(data, res);
    });
  },
  async budget({ commit }, data) {
    return await Service.Dashboard.budget(data.payload).then((res) => {
      return checkAndReturn(data, res);
    });
  },
  async budgetList({ commit }, data) {
    return await Service.Dashboard.budgetList(data.payload).then((res) => {
      return checkAndReturn(data, res);
    });
  },
  async progress({ commit }, data) {
    return await Service.Dashboard.progress(data.payload).then((res) => {
      return checkAndReturn(data, res);
    });
  },
  async budgetMap({ commit }, data) {
    return await Service.Dashboard.budgetMap(data.payload).then((res) => {
      return checkAndReturn(data, res);
    });
  },
  async refresh({ commit }, data) {
    return await Service.Dashboard.refresh(data.payload).then((res) => {
      return checkAndReturn(data, res);
    });
  },
  async region({ commit }, data) {
    return await Service.Dashboard.region().then((res) => {
      return checkAndReturn(data, res);
    });
  },
  async plans({ commit }, data) {
    return await Service.Dashboard.plans().then((res) => {
      return checkAndReturn(data, res);
    });
  },
  async building({ commit }, data) {
    return await Service.Dashboard.building(data.payload).then((res) => {
      return checkAndReturn(data, res);
    });
  },
};

const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
